<template>
  <div
    class="hs-checkbox"
    :class="{ gray: !value }"
    v-if="checkboxLogo && checkboxLogo.length >= 2"
  >
    <div class="checkbox-outer-gender">
      <div
        class="logo-back"
        :style="{
          backgroundImage: `url(${value ? require('@/assets/image/base/check-box/' + checkboxLogo[0]) : require('@/assets/image/base/check-box/' + checkboxLogo[1])})`,
        }"
      >
        <div class="logo"></div>
      </div>
    </div>
    <p>{{ title }}</p>
  </div>
  <div v-else class="hs-checkbox">
    <div class="checkbox-outer">
      <div class="logo-back" :class="{ beSmall: !value }">
        <div class="logo"></div>
      </div>
    </div>
    <p>{{ title }}</p>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    value: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    checkboxLogo: { // 0 选中的icon 1 未选中的icon
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      list: []
    }
  },
  mounted() {
    this.list = this.checkboxLogo
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-checkbox
  @extend .flex-row
  @extend .flex-start
  height 20px
  >.checkbox-outer
    // @extend .flex-center
    width 16px
    height 16px
    border 1px solid $color_theme
    border-radius 8px
    position relative
    margin-right 8px
    >.logo-back
      position absolute
      top -1px
      left -1px
      width 16px
      height 16px
      border-radius 8px
      // background-color $color_theme
      transition all 200ms
      transform scale(1)
      overflow hidden
      background url(@/assets/image/base/check-box/single_1.png) no-repeat
      background-size 100% 100%
      /*>.logo
        position absolute
        top 2px
        left 5px
        width 6px
        height 9px
        border-right 1px solid $color_white
        border-bottom 1px solid $color_white
        transform rotate(45deg)*/
    >.beSmall
      transform scale(0)
  >p
    font-size 0.9rem
  >.checkbox-outer-gender
    @extends .flex-start
    flex-shrink 0
    width 16px
    height 16px
    position relative
    margin-right 8px
    >.logo-back
      flex-shrink 0
      width 100%
      height 100%
      background-repeat no-repeat
      background-position center
      background-size 100% 100%
  &[type='big']
    .checkbox-outer-gender
      width 20px
      height 20px
  &.gray
    p
      color $color_font_gray_3
  &[type='normal-big']
    p
      color $color_font_black
      font-size 15px
    .checkbox-outer-gender
      width 16px
      height 16px
      margin-right 12px
</style>
